import React, { useEffect, useState } from "react";
import WithAuth from "../../hoc/WithAuth";
import TableAction from "../../components/TableAction";
import { useCustomerList } from "../../api/customer";
import { Button, Checkbox, Collapse, Input, Table } from "antd";
import { useNavigate, useSearchParams } from "react-router-dom";
import dayjs from "dayjs";
import { AuthContextValue, useAuth } from "../../providers/AuthProvider";
import { ColumnsType } from "antd/es/table";
import { AlignCenter } from "lucide";

const CustomerPage = () => {
  const [tableData, setTableData] = useState<any[]>([]);
  const [fullData, setFullData] = useState<any[]>([]);
  const [viewAll, setViewAll] = useState(false);
  const navigate = useNavigate();
  const [searchText, setSearchText] = useState("");
  const { user } = useAuth() as AuthContextValue;
  const [searchParams, setSearchParams] = useSearchParams();
  const savedPage = Number(sessionStorage.getItem("currentPage")) || 1;
  const urlPage = Number(searchParams.get("page")) || savedPage;

  const [pagination, setPagination] = useState({
    current: urlPage,
    pageSize: 10,
    total: 0,
  });

  const { data: customers, isLoading } = useCustomerList(
    searchText,
    pagination.current - 1,
    pagination.pageSize
  );

  const columns:ColumnsType<any>  = [
    {
      dataIndex: "customerId",
      title: "Customer ID",
      width: 120,
    },
    {
      dataIndex: "bankAccount",
      title: "Bank Account",
      width: 150,
    },
    {
      dataIndex: "identificationNumber",
      title: "ID No.",
      width: 100,
    },
    {
      dataIndex: "fullName",
      title: "Full Name",
      width: 200,
      // align: "center",
    },
    // {
    //   dataIndex: "gender",
    //   title: "Gender",
    //   width: 100,
    // },
    {
      dataIndex: "phoneNumber",
      title: "Phone No.",
      width: 150,
    },
    {
      dataIndex: "tinNumber",
      title: "TIN",
      width: 150,
      render: (tin: string) => <div>{tin ? tin : "N/A"}</div>,
    },
  ];
  

  
 


  useEffect(() => {
    if (customers?.data?.content) {
      setFullData(customers.data.content);
      setPagination((prev) => ({
        ...prev,
        total: customers.data.totalElements,
        current: customers.data.number + 1,
        pageSize: customers.data.size,
      }));
    }
  }, [customers]);

  useEffect(() => {
    if (fullData.length > 0) {
      let filteredData = fullData; // Use full dataset
  
      if (searchText) {
        filteredData = fullData.filter(
          (item) =>
            item.customerId?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.identificationNumber
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.fullName?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.dateOfBirth
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.gender?.toLowerCase().includes(searchText.toLowerCase()) ||
            item.phoneNumber
              ?.toLowerCase()
              .includes(searchText.toLowerCase()) ||
            item.tinNumber?.toLowerCase().includes(searchText.toLowerCase())
        );
      }
  
      setTableData(filteredData);
    }
  }, [searchText, fullData]);
  

  // Handle table pagination changes
  const handleTableChange = (newPagination: any) => {
    setPagination({
      ...newPagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
    sessionStorage.setItem("currentPage", newPagination.current);
  };

  return (
    <div className="px-2 md:mx-[50px]">
      <div
        className="hidden md:block"
        style={{
          borderRadius: 8.5,
          paddingRight: 50,
          paddingLeft: 50,
          paddingTop: 22,
          backgroundColor: "white",
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            height: 80,
            backgroundColor: "#EEF3F8",
            borderRadius: 8.4,
            marginBottom: 12,
            overflowY: "auto",
          }}
        >
          <TableAction setSearchText={setSearchText} />
          {user && user.roleName === "ROLE_KFT_SP_ADMIN" && (
            <Button
              className="mr-4"
              onClick={() => navigate("/importCustomers")}
            >
              Import
            </Button>
          )}
        </div>
        <div className="flex h-full" style={{ overflow: "hidden" }}>
          <Table
          style={{
            cursor: "pointer",
            position: "relative",
            zIndex: 100,
            overflowY:"hidden"
          }}
          scroll={{ y: 600 }} 
          onRow={(record, index) => {
            return {
              onClick: (event) => {
                navigate(`/customers/${record.id}`);
              },
            };
          }}
          dataSource={tableData}
          columns={columns.map((col) => ({
            ...col,
            title: col.title,
            onHeaderCell: () => ({
              style: {
                position: "sticky",
                top: 0,
                background: "white", 
                zIndex: 10, 
              },
            }),
          }))}
          loading={isLoading}
          pagination={{
            current: pagination.current,
            pageSize: pagination.pageSize,
            total: pagination.total,
            showSizeChanger: true,
            showTotal: (total) => `Total ${total} customers`,
          }}
          onChange={handleTableChange}
        />
        </div>
        
      </div>

      <div className="flex flex-col gap-2 md:hidden">
        <div className="flex justify-between items-center border-b-2 border-gray-400 pb-2">
          <Input
            onChange={(e) => setSearchText(e.target.value)}
            placeholder="Search"
            style={{
              backgroundColor: "#08453E",
              color: "white",
              width: "75%",
              height: 40,
            }}
          />
          {tableData.length > 5 && (
            <div className="mb-2">
              <Checkbox onChange={(val) => setViewAll(val.target.checked)}>
                View All
              </Checkbox>
            </div>
          )}
        </div>
        {tableData &&
          tableData
            .slice(0, viewAll ? tableData.length : 5)
            .map((item: any) => {
              return (
                <Collapse
                  className="mb-1"
                  accordion
                  items={[
                    {
                      key: item.id,
                      label: item.fullName,
                      children: (
                        <div className="flex justify-between items-start">
                          <div className="flex flex-col gap-1">
                            <div>Id: {item.identificationNumber}</div>
                            <div>Customer Id: {item.customerId}</div>
                            <div>Gender. - {item.gender}</div>
                            <div>Phone. - {item.phoneNumber}</div>
                            <div>Date of Birth: {item.dbo}</div>
                          </div>
                          <div className="flex flex-col gap-1">
                            <div>Bank name: {item.bankAccountName}</div>
                            <div>Account No. - {item.bankAccount}</div>
                            <div>TIN - {item.tinNo}</div>
                          </div>
                        </div>
                      ),
                    },
                  ]}
                />
              );
            })}
      </div>
    </div>
  );
};

export default WithAuth(CustomerPage);
